<template>
  <div class="personalMain">
    <p class="current">当前位置：<span>个人中心</span></p>
    <div class="personal-box">
      <Menu></Menu>
      <div class="MainInfo">
        <div class="infoHeader">
          <div class="userAccount " v-if="loginIs">
            <img src="../../assets/logo666.png" alt="">
        
            <div>
              <p>{{ userInfo.user_mobile }}</p>
              <span>ID:{{ userInfo.user_id }}</span>
            </div>
          </div>
          <div v-else>
            <el-button @click="handleLogin">登陆</el-button>
            <el-button @click="handleRegister">注册</el-button>
          </div>
          <div class="userType">
            <el-button  round v-if="userInfo.company2_amount == 0" @click="uconfigJoin">升级企业用户</el-button>
            <el-button  round v-else >企业用户</el-button>
          </div>
        </div>
        <div class="infoContext">
          <div class="HeaderFlex">
              <div class="flexItem" @click="HandleMyProfitMoney">
                <p>{{ loginIs?userInfo.ProfitMoney:'0' }}</p>
                <span>收益</span>
              </div>
              <div class="flexItem" @click="HandlemyUserMoney">
                <p>{{ loginIs?userInfo.UserMoney:'0' }}</p>
                <span>钱包</span>
              </div>
              <div class="flexItem" @click="integral">
                <p>{{ loginIs?userInfo.ProfitJifen:0 }}</p>
                <span>积分</span>
              </div>
              <div class="flexItem" @click="teams">
                <p>{{ loginIs?userInfo.TeamNum:0 }}</p>
                <span>团队</span>
              </div>
          </div>
        </div>
        <div class="infoContext" style="border: none">
          <div class="myPer">
            <p>我的订单</p>
            <span @click="myOrders('all')">全部</span>
          </div>
          <div class="HeaderFlex" >
              <div class="flexItem" @click="myOrders('notpay')">
                <img src="../../assets/icon-fukuan.png" alt="">
                <span>待付款</span>
              </div>
              <div class="flexItem" @click="myOrders('pay')">
                <img src="../../assets/icon-fahuo.png" alt="">
                <span>待发货</span>
              </div>
              <div class="flexItem" @click="myOrders('express')">
                <img src="../../assets/icon-huanhuo.png" alt="">
                <span>待收货</span>
              </div>
              <div class="flexItem" @click="myOrders('confirm')">
                <img src="../../assets/icon-wancheng.png" alt="">
                <span>已完成</span>
              </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  
</template>

<script>
import Menu from './index.vue'
export default{
  data(){
    return{
      userInfo: {},
      loginIs: true
    }
  },
  components:{
    Menu
  },
  methods: {
    integral(){
      this.$router.push({
        path: '/integral'
      })
    },
    teams(){
      this.$router.push({
        path: '/teams'
      })
    },
    myOrders(val){
      this.$router.push({
        path: "/myOrders",
        query: {
          vsstatus: val
        }
      });
    },
    uconfigJoin(){
      this.$router.push({
        path: '/uconfigJoin'
      })
    },
    HandleMyProfitMoney(){
      this.$router.push({
        path: '/myProfitMoney'
      })
    },
    HandlemyUserMoney(){
      this.$router.push({
        path: '/myUserMoney'
      })
    },
    handleRegister(){
      this.$router.push('/register')
    },
    handleLogin(){
      this.$router.push('/login')
    }
  },
  mounted(){
    let data = {}
    this.$store.dispatch('personal/user',data)
      .then(res => {
        if(res.ok){
          this.userInfo = res.data
          
          var info = res.data
          var roles = []
          roles = info.roles

          // this.iscompany = this.UniUserRole('company')
          // this.isexpert = this.UniUserRole('isexpert')
          
          sessionStorage.setItem('qiliangongRoles', JSON.stringify(roles))
          sessionStorage.setItem('qiliangongIsCustUser', info.IsCustUser)
          sessionStorage.setItem('qiliangongIsExpert', info.IsExpert)
        }else{
          this.loginIs = false
        }
        // else if(res.code == -1 && res.msg == '未登录或超时'){
        //   this.$notify({
        //       title: '提示',
        //       message: '未登录或超时，请重新登陆',
        //       type: 'error'
        //   })
        //   this.$router.push('/login')
         
        // }
      })
  }
}
</script>

<style scoped>
@import url(../../css/personal.css);
.infoHeader{
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 20px;
}
.userAccount{
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.userAccount img{
  width: 60px; height: 60px
}
.userAccount div{
  margin-left: 20px;
}
.userAccount span{
  font-size: 16px;
  color: #666666;
  margin-left: 3px;
}
.infoContext{
  margin: 0px auto;
  border-bottom: 0.5px solid #f2f2f2;
  font-size: 20px;
}
.HeaderFlex{
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 40px auto;
}
.flexItem{
  text-align: center;
  cursor: pointer;
}
.flexItem span{
  font-size: 16px;
  color: #666666;
}
.flexItem img{
  display: block;
  margin: 0 auto;
  margin-bottom: 10px;
  width: 36px;height: 36px;
}
.myPer{
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 40px;
  font-size: 17px;
  padding: 10px 40px;
  border-bottom: 0.5px solid #f2f2f2;
}
.myPer span{
  font-size: 16px;
  color: #666666;
  cursor: pointer;
}
@media screen and (min-width: 541px) {
  .HeaderFlex{
    width: 90%;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 40px auto;
  }
}

@import url(../../css/personal540.css);
</style>